import apiFetch from '../apiFetch'

export default function (codRaza, token) {
  return apiFetch({endPoint: `FichaVerraco/getAsignarCodRaza`, method: 'POST', body: {codRaza}, token: token})
}
